/** Pick Setup step 4 test destination from templates + active rules. */

export const resolveSetupTestNavigation = (templates = [], rules = []) => {
  const activeRule = rules.find((r) => r.status === "active");
  const ruleChannel = activeRule?.channel;

  if (ruleChannel === "voice_call") {
    return { tab: "voice", focus: "test" };
  }
  if (ruleChannel === "whatsapp") {
    return { tab: "templates", focus: "test" };
  }

  const hasWhatsApp = templates.some(
    (t) => !t.channel || t.channel === "whatsapp"
  );
  const hasVoice = templates.some(
    (t) => t.channel === "voice_call" || t.channel === "voice"
  );

  if (hasWhatsApp && !hasVoice) {
    return { tab: "templates", focus: "test" };
  }

  return { tab: "voice", focus: "test" };
};
